module.exports = __webpack_public_path__ + "static/fr.manifest.6d50478d.webmanifest";